import { memo } from 'react';
import { ErrorTemplate } from 'components/templates/ErrorTemplate';

type Props = {};

export const ErrorPage = memo((_props: Props) => {
	return <ErrorTemplate />;
});
